import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPriority = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M2.77295 10.2727C2.77295 9.99656 2.99681 9.77271 3.27295 9.77271V9.77271C3.54909 9.77271 3.77295 9.99656 3.77295 10.2727V14C3.77295 14.2761 3.54909 14.5 3.27295 14.5V14.5C2.99681 14.5 2.77295 14.2761 2.77295 14V10.2727Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.5 6.13635C7.5 5.86021 7.72386 5.63635 8 5.63635V5.63635C8.27614 5.63635 8.5 5.86021 8.5 6.13635V14C8.5 14.2761 8.27614 14.5 8 14.5V14.5C7.72386 14.5 7.5 14.2761 7.5 14V6.13635Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 12.2271,
			y: 1.5,
			width: 1,
			height: 13,
			rx: .5,
			fill: "currentColor"
		})
	]
});
export default SvgPriority;
